export default __webpack_public_path__ + "static/media/vodacom.3251a534.png";